import { createActions } from 'redux-actions';
import { put, select } from 'redux-saga/effects';
import { apiActionResult, apiResourceActionCreator } from '../../common';
import { authTokenSelector } from '../../session';
import getCpdCategorysConfig from './getCpdCategorys';
import { apiAction as updateIndustryRoleApiAction, default as updateIndustryRoleConfig } from './updateIndustryRole';

const actions = createActions({
  USER: {
    API: {
      SET_INDUSTRY_ROLE: apiResourceActionCreator('cpdCategorys')
    },
    SET_INDUSTRY_ROLE: (payload) => (payload)
  }
})

export function* setIndustryRole(action) {
  const authToken = yield select(authTokenSelector);

  if (authToken.idToken) {
    yield put(updateIndustryRoleApiAction(authToken, action.payload.industry));

    const updateIndustryRoleResult = yield apiActionResult(updateIndustryRoleConfig.action.user.api.updateIndustryRole);

    if (updateIndustryRoleResult.success) {
      yield put(getCpdCategorysConfig.action.user.getCpdCategorys(action.payload.industry.userId));
    }
  }
}

const configuration = {
  name: 'setIndustryRole',
  action: actions,
  sagas: setIndustryRole,
  reducers: {

  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/user/configurations/setIndustryRole.js